


export const scrollStyleClass = "[&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-transparrent [&::-webkit-scrollbar-thumb]:bg-scrollbar-thumb"